import React, { ReactNode } from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './WidgetEmptyPlaceholder.module.scss';

type WidgetEmptyPlaceholderProps = {
  title: string;
  icon: ReactNode;
  text: ReactNode;
};

const WidgetEmptyPlaceholder = ({ title, icon, text }: WidgetEmptyPlaceholderProps) => (
  <div className={classes.content}>
    {icon}
    <TitleWithDescription title={title} description={text} />
  </div>
);

export { WidgetEmptyPlaceholder };
